import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";
import {
    templatesService,
    subOrganizationTreeService,
    tagsTreeService,
    usersPermissionsService
} from '../../services/feathers.service';

const initialState = {
    resourcePaneFlag: null,
    isNameAvailable: true,
    teamsTree: [],
    tagsTree: [],
    tagMap: null,
    authorizedUsers: [],
    templatesArray: {},
    teamMap: null,
    selectedTemplate: {},
    splitAtSize: null,
};



export default {
    state: initialState,
    reducers: {
        showResourecePaneFlagSet(state, payload) {
            return {
                ...state,
                resourcePaneFlag: payload
            }
        },
        setNameAvailabilityFlag(state, payload) {
            return {
                ...state,
                isNameAvailable: payload
            }
        },
        setTeamList(state, payload) {
            let teamMap = new Map()
            const traverserTeams = (teams, parent) => {

                teams.forEach((team, index) => {
                    if (parent) {
                        team.path = `${parent.path}/${index}`;
                    }
                    else {
                        team.path = `${index}`;
                    }
                    teamMap.set(team._id.toString(), team);
                    if (team.nodes) {
                        traverserTeams(team.nodes, team)
                    }
                })
            }
            traverserTeams(payload)

            return {
                ...state,
                teamsTree: payload,
                teamMap: teamMap
            }
        },
        setTagsTree(state, payload) {
            let tagMap = new Map();
            for (let [index, baseTag] of payload.entries()) {
                baseTag.path = `${index}`;
                baseTag.depth = 0;
                tagMap.set(baseTag.id ? baseTag.id.toString() : baseTag._id.toString(), baseTag);
                if (baseTag.nodes) {
                    for (let [tagIndex, tag] of baseTag.nodes.entries()) {
                        tag.path = `${index}/${tagIndex}`;
                        tag.depth = 1;
                        tagMap.set(tag.id ? tag.id.toString() : tag._id.toString(), tag);
                        if (tag.nodes) {
                            for (let [subTagIndex, subTag] of tag.nodes.entries()) {
                                subTag.path = `${index}/${tagIndex}/${subTagIndex}`;
                                subTag.depth = 2;
                                tagMap.set(subTag.id ? subTag.id.toString() : subTag._id.toString(), subTag)
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                tagsTree: payload,
                tagMap: tagMap
            }
        },
        setAuthorizedUsers(state, payload) {
            return {
                ...state,
                authorizedUsers: payload
            }
        },
        setTemplatesArray(state, payload) {
            return {
                ...state,
                templatesArray: payload
            }
        },
        setSelectedTemplate(state, payload) {
            return {
                ...state,
                selectedTemplate: payload
            }
        },
        setSplitAtSize(state, payload) {
            return {
                ...state,
                splitAtSize: payload
            }
        },
    },
    effects: {
        showResourecePane(payload) {
            dispatch.templates.showResourecePaneFlagSet(payload);
            return;
        },
        async getMyTemplates(payload) {
            try {
                let query = {
                    $limit: payload.limit,
                    $sort: { status: 0 }
                }
                let myTemplates = await templatesService.find({ query: query });
                dispatch.templates.setTemplatesArray(myTemplates);
            } catch (error) {
                throw error
            }

        },
        async searchTemplateByName(payload) {
            let template = await templatesService.find({ query: payload });
            if (template.data && template.data.length > 0) {
                dispatch.templates.setNameAvailabilityFlag(false);
            }
            else {
                dispatch.templates.setNameAvailabilityFlag(true);
            }
        },
        async getSuborgByOrgId(payload) {
            const teamList = await subOrganizationTreeService.get(payload.organizationId, { query: { teamId: payload.organizationId } })
            await dispatch.templates.setTeamList(teamList);
        },
        async createTemplate(payload) {
            let createdTemplate = await templatesService.create(payload);
            return dispatch(push(`/app/${createdTemplate.accountId}/_ws/${createdTemplate.organizationId}/_tc`));
        },
        async getTagsTree(payload) {
            let tagsTree = await tagsTreeService.find();
            await dispatch.templates.setTagsTree(tagsTree);
        },
        async refreshTagsTree(payload, state) {
            if (state.app.currentContext === 'template' && payload.accountId && state.app.selectedAccount && state.app.selectedAccount._id && state.app.selectedAccount._id.toString() === payload.accountId.toString()) {
                let tagsTree = await tagsTreeService.find();
                dispatch.templates.setTagsTree(tagsTree);
            }

        },
        async getAuthorizedUsersForTemplateCreation(payload) {
            let data;
            if (payload && payload.searchParam) {
                data = await usersPermissionsService.find({ query: { permission: "templateCreation", queryParam: payload.searchParam, contributors: payload.contributors } });
            }
            else {
                data = await usersPermissionsService.find({ query: { permission: "templateCreation", contributors: payload.contributors } });
            }
            dispatch.templates.setAuthorizedUsers(data);
        },
        updateTemplateList(data, state) {
            if (data.contributors.filter(contributor => { return contributor.accountUserId.toString() === state.app.user._id.toString() }) && state.app.currentContext === 'template') {
                try {
                    if (!state.templates.templatesArray.data) {
                        state.templates.templatesArray.data = []
                    }
                    state.templates.templatesArray.data = [...state.templates.templatesArray.data, data]
                }
                catch (e) {
                    throw e;
                }

                dispatch.templates.setTemplatesArray(Object.assign({}, state.templates.templatesArray));
            }
        },
        async getSelectedTemplate(payload) {
            let templateData = await templatesService.get(payload, {
                query: {
                    $populate: [
                        { path: 'contributors.accountUserId', populate: 'accountUserId', select: '_id firstName lastName profilePic email' },
                        { path: 'tags', populate: 'tags' },
                        { path: 'teams', populate: 'teams' },
                        { path: 'createdBy', populate: 'createdBy', select: '_id firstName lastName profilePic email' }
                    ]
                }
            })
            await dispatch.templates.setSelectedTemplate(templateData);
        },
        splitAt(payload) {
            dispatch.templates.setSplitAtSize(payload)
        },

    }
}